/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_ManageInputs */



/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Rounds_ManageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_manage = /** @type {((inputs?: Rounds_ManageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_ManageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestionar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Gerir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci")
	return /** @type {LocalizedString} */ ("Manage")
});